import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router'
import { Collapse, Layout, PageHeader, Icon, Button, Card } from 'antd'
import { agentPayments, files } from '@services/api'
import { inject, observer } from 'mobx-react'
import UploadCommissionsPopup from '@components/Popup/UploadCommissionsPopup'
import BulkPay from './BulkPay'
import ExportFiles from './ExportFiles'
import Files from './Files'
import Reports from './Reports'
import MentorCommissions from './MentorCommissions'
import MentorCommissionReports from './MentorCommissionReports'
import CurrentMonthReports from '@pages/AgentCommissions/CurrentMonthReports'

@inject((store: any) => {
    const { popupStore, authStore } = store
    return { popupStore, authStore }
})
@observer
class AgentCommissions extends Component<any, any> {
    state = {
        commissionsFiles: [],
        commissionExportFiles: [],
        lastPayment: '',
        searchParams: {},
        paramsRules: ['page', 'month', 'year']
    }

    componentDidMount() {
        this.redirect()
        this.getCommissionFile()
        this.getCommissionExportFiles()
        this.getLastPayment()
    }

    getLastPayment = () => {
        agentPayments.getLastPayment().then(({ data }) => {
            this.setState({ lastPayment: data })
        })
    }

    generateMonthlyCommissionFile = () => {
        files
            .generateMonthlyCommissionFile()
            .then(() => {
                this.getCommissionFile()
                alert('קובץ עמלות חודשי נוצר בהצלחה')
            })
            .catch(() => alert('אירעה שגיאה. קובץ עמלות לא נוצר.'))
    }

    getCommissionFile = () => {
        files.commissions({}).then(res => {
            this.setState({ commissionsFiles: res.data })
        })
    }

    getCommissionExportFiles = () => {
        files.commissionExports({}).then(res => {
            this.setState({ commissionExportFiles: res.data })
        })
    }

    resetSearchQuery = async () => {
        await this.setState({ searchParams: {} })
        await this.redirect()
    }

    updateSearchQuery = async () => {
        await this.updateParam('page', '1')
        await this.redirect()
    }

    updatePage = async value => {
        await this.updateParam('page', value)
        await this.redirect()
    }

    updateParam = (name, value) => {
        this.setState(prevState => ({ ...prevState, searchParams: { ...prevState.searchParams, [name]: value } }))
    }

    redirect = () => {
        const { searchParams, paramsRules } = this.state
        let qs
        if (!searchParams['page']) searchParams['page'] = 1
        paramsRules.forEach(key => {
            if (searchParams[key]) qs ? (qs += `&${key}=${searchParams[key]}`) : (qs = `${key}=${searchParams[key]}`)
        })
        this.props.history.push(`/AgentCommissions${qs ? `?${qs}` : ''}`)
    }

    render() {
        const {
            popupStore: { togglePopup },
            authStore: { roles }
        } = this.props
        let { commissionsFiles, commissionExportFiles, lastPayment } = this.state
        commissionsFiles.sort(function(a, b) {
            let aArr = a.file_name.split('-')
            let bArr = b.file_name.split('-')
            if (aArr[1] === bArr[1]) {
                return bArr[0] - aArr[0]
            }
            return aArr[1] < bArr[1] ? 1 : -1
        })

        return (
            <Layout>
                <PageHeader onBack={() => window.history.back()} title="ניהול עמלות סוכנים">
                    <Collapse accordion defaultActiveKey={'0'}>
                        <Collapse.Panel header="עמלות" key={'0'}>
                            <Reports getCommissionExportFiles={this.getCommissionExportFiles} />
                        </Collapse.Panel>
                        <Collapse.Panel header="קבצי עמלות לפי בקשה" key="commission-exports">
                            <Card
                                headStyle={{ backgroundColor: '#dadce0' }}
                                bodyStyle={{ padding: '0.8rem 0.8rem' }}
                                style={{ marginBottom: '1rem' }}
                            >
                                <ExportFiles
                                    list={commissionExportFiles ? commissionExportFiles : []}
                                    getCommissionExportFiles={this.getCommissionExportFiles}
                                />
                            </Card>
                        </Collapse.Panel>
                        <Collapse.Panel header={'עמלות חודש נוכחי'}>
                            <CurrentMonthReports getCommissionFile={this.getCommissionFile} />
                        </Collapse.Panel>
                        <Collapse.Panel header="קבצי עמלות חודשיים">
                            <Card
                                title={
                                    <Fragment>
                                        <Button
                                            onClick={() =>
                                                togglePopup('uploadFile', {
                                                    bucket: 'commissions',
                                                    types: ['commission']
                                                })
                                            }
                                            style={{ float: 'left', margin: '-0.3rem 2rem' }}
                                        >
                                            <Icon type="upload" /> העלאת קובץ
                                        </Button>

                                        {(roles.includes('admin') || roles.includes('money')) && (
                                            <Button
                                                onClick={this.generateMonthlyCommissionFile}
                                                style={{ float: 'left', margin: '-0.3rem 0' }}
                                            >
                                                יצירת קובץ עמלות חודשי
                                            </Button>
                                        )}
                                        <UploadCommissionsPopup fileUploaded={() => console.log('done')} />
                                    </Fragment>
                                }
                                headStyle={{ backgroundColor: '#dadce0' }}
                                bodyStyle={{ padding: '0.8rem 0.8rem' }}
                                style={{ marginBottom: '1rem' }}
                            >
                                <Files
                                    list={commissionsFiles ? commissionsFiles : []}
                                    lastPayment={lastPayment}
                                    getLastPayment={this.getLastPayment}
                                    getCommissionFile={this.getCommissionFile}
                                />
                            </Card>
                        </Collapse.Panel>

                        {roles.includes('admin') || roles.includes('money') ? (
                            <Collapse.Panel header="עדכון תשלומים">
                                <BulkPay />
                            </Collapse.Panel>
                        ) : (
                            ''
                        )}

                        <Collapse.Panel header={'עמלות מנטורים'}>
                            <MentorCommissions />
                        </Collapse.Panel>

                        <Collapse.Panel header={'עמלות מנטורים - דו״ח'}>
                            <MentorCommissionReports />
                        </Collapse.Panel>
                    </Collapse>
                </PageHeader>
            </Layout>
        )
    }
}

export default withRouter(AgentCommissions)
